export default __webpack_public_path__ + "static/media/Irene Maria Jijo1.1edaff6c.jpg";